import { PropsWithChildren } from 'react'

type RootProps = {}

export const Root = ({ children }: PropsWithChildren<RootProps>) => (
  <div>{children}</div>
)
